import { JobStatusEnum } from "@/types/job";

export const jobStatusValues: Record<string, JobStatusEnum> = {
  Draft: "Draft",
  Active: "Active",
  Underscreening: "Underscreening",
  Closed: "Closed",
  Rejected: "Rejected",
  Hold: "Hold",
};

export const jobStatusOption: {
  value: JobStatusEnum;
  label: string;
}[] = [
  { value: jobStatusValues.Draft, label: "Draft" },
  { value: jobStatusValues.Active, label: "Active" },
  // { value: jobStatusValues.Underscreening, label: "Underscreening" },
  { value: jobStatusValues.Closed, label: "Close" },
  { value: jobStatusValues.Hold, label: "On-Hold" },
  // { value: jobStatusValues.Rejected, label: "Reject" },
];
